import { useState } from "react";
import { toast } from "sonner";
import { CheckSquare, Loader2, Square, Trash2, X } from "lucide-react";
import { Button } from "../ui/button";

// Selection state for bulk actions on a list of rows with `id`.
export const useBulkSelect = () => {
  const [sel, setSel] = useState(() => new Set());
  const toggle = (id) => setSel((p) => { const n = new Set(p); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const setAll = (ids) => setSel(new Set(ids));
  const clear = () => setSel(new Set());
  return { sel, toggle, setAll, clear };
};

export const RowCheck = ({ checked, onChange, testid, disabled, title }) => (
  <button type="button" onClick={(e) => { e.stopPropagation(); if (!disabled) onChange(); }} data-testid={testid} title={title}
    className={`grid h-6 w-6 shrink-0 place-items-center rounded transition-colors ${disabled ? "cursor-not-allowed text-slate-200" : checked ? "text-emerald-600" : "text-slate-300 hover:text-slate-500"}`}>
    {checked ? <CheckSquare className="h-5 w-5" /> : <Square className="h-5 w-5" />}
  </button>
);

export const BulkBar = ({ bulk, allIds, onDelete, noun = "عنصر", note, prefix = "bulk" }) => {
  const [busy, setBusy] = useState(false);
  const ids = [...bulk.sel].filter((id) => allIds.includes(id));
  const n = ids.length;
  const all = allIds.length > 0 && allIds.every((id) => bulk.sel.has(id));
  const run = async () => {
    if (!window.confirm(`حذف ${n} ${noun} نهائياً؟ لا يمكن التراجع.`)) return;
    setBusy(true);
    try {
      const r = await onDelete(ids);
      toast.success(`تم حذف ${r.deleted}${r.skipped ? ` — وتم تخطّي ${r.skipped} (${note || "غير مسموح بحذفها"})` : ""}`);
      bulk.clear();
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحذف"); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-xl border border-slate-200 bg-slate-50 px-3 py-2" data-testid={`${prefix}-bar`}>
      <RowCheck checked={all} onChange={() => (all ? bulk.clear() : bulk.setAll(allIds))} testid={`${prefix}-select-all`} title="تحديد الكل" />
      <span className="text-xs font-semibold text-slate-600" data-testid={`${prefix}-count`}>{n ? `${n} محدد` : `تحديد الكل (${allIds.length})`}</span>
      {note && <span className="text-[11px] text-slate-400">{note}</span>}
      {n > 0 && <>
        <Button size="sm" variant="destructive" className="mr-auto gap-1.5" disabled={busy} onClick={run} data-testid={`${prefix}-delete`}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Trash2 className="h-4 w-4" />} حذف المحدد ({n})</Button>
        <Button size="sm" variant="ghost" className="gap-1" onClick={bulk.clear} data-testid={`${prefix}-clear`}><X className="h-4 w-4" /> إلغاء</Button>
      </>}
    </div>
  );
};
